// extracted by mini-css-extract-plugin
module.exports = {"login":"LoginButton_login__10Kwp","button":"LoginButton_button__1BDMZ","icon":"LoginButton_icon__1ISg5","text":"LoginButton_text__3JcNN"};